import React from "react";
import PropTypes from "prop-types";

// @mui/material components
import Grid from "@mui/material/Grid";
import { ToggleOff, ToggleOn } from "@mui/icons-material";

// core components
import ItemName from "components/List/components/ItemName";
import DateLabel from "components/List/components/Date";
import Hour from "components/List/components/Hour";
import StyledLine from "components/List/components/StyledLine";
import IconButton from "components/button/IconButton";
import EditIcon from "components/icons/EditIcon";

// styles
import { borderGrayColor, green500 } from "assets/jss/main";

BrandLine.propTypes = {
    brand: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
};

// Column widths are kept in sync with TableHeader so values line up with headers.
function BrandLine({ brand, onEdit }) {
    return (
        <StyledLine xs={12} justifyContent={"space-between"} alignItems={"center"}>
            <Grid item container xs={6} flexWrap={"nowrap"} alignItems={"center"}>
                <Grid item zeroMinWidth>
                    <ItemName label={brand.name} />
                </Grid>
            </Grid>
            <Grid
                item
                container
                xs={6}
                columnSpacing={2}
                justifyContent={"flex-end"}
                alignItems={"center"}
                flexWrap={"nowrap"}
            >
                <Grid item sx={{ width: "130px", textAlign: "center" }}>
                    {brand.productsCount ?? 0}
                </Grid>
                <Grid item sx={{ width: "70px", textAlign: "center" }}>
                    {brand.enabled ? (
                        <ToggleOn style={{ color: green500 }} />
                    ) : (
                        <ToggleOff style={{ color: borderGrayColor }} />
                    )}
                </Grid>
                <Grid item sx={{ width: "100px" }}>
                    <DateLabel date={brand.updatedAt} />
                </Grid>
                <Grid item sx={{ width: "60px" }}>
                    <Hour date={brand.updatedAt} />
                </Grid>
                <Grid item container justifyContent={"flex-end"} sx={{ width: "70px" }}>
                    <Grid item>
                        <IconButton onMouseDown={(e) => { e.stopPropagation(); onEdit(brand); }}>
                            <EditIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
        </StyledLine>
    );
}

export default BrandLine;
